import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import HeaderView from '@/components/HeaderView.vue'
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter()
const showHeader = ref(false)
const height = ref('height:100%')
watch(
    () => router.currentRoute.value.fullPath,
    newValue => {
        if (newValue !== '/login' && newValue.indexOf('/device') === -1) {
            showHeader.value = true
            height.value = 'calc(100% - 64px)'
        } else {
            showHeader.value = false
            height.value = 'height:100%'
        }
    }
)

const debounce = (callback: any, delay: number) => {
    let tid: any
    return function () {
        const ctx = self
        tid && clearTimeout(tid)
        tid = setTimeout(() => {
            callback.apply(ctx, arguments)
        }, delay)
    }
}

const _ = (window as any).ResizeObserver
;(window as any).ResizeObserver = class ResizeObserver extends _ {
    constructor(callback: any) {
        callback = debounce(callback, 20)
        super(callback)
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showHeader.value)
      ? (_openBlock(), _createBlock(HeaderView, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["router-view", { 'router-view2': !showHeader.value }])
    }, [
      _createVNode(_component_router_view)
    ], 2)
  ], 64))
}
}

})